export enum TabIndex {
  Security = 0,
  ANPR = 1
}

export const DEFAULT_ID = -1;
export const ALL = 'All';
